import { createContext, useContext, useState, useCallback } from 'react';
import Toast from '../components/Toast';

const ToastContext = createContext(null);

// Wrap the whole app with <ToastProvider> once, then call useToast()
// from ANY component to show a success/error popup — no prop drilling needed.
export function ToastProvider({ children }) {
  const [toast, setToast] = useState(null); // { type, message } or null

  const showToast = useCallback((type, message) => {
    setToast({ type, message });

    // Auto-dismiss after 3 seconds
    setTimeout(() => {
      setToast(null);
    }, 3000);
  }, []);

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}

      {/* Rendered once, at the top level, above everything else */}
      {toast && (
        <div style={styles.container}>
          <Toast type={toast.type} message={toast.message} />
        </div>
      )}
    </ToastContext.Provider>
  );
}

export function useToast() {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
}

const styles = {
 container: {
    position: 'fixed',
    top: 'calc(16px + env(safe-area-inset-top))',
    left: 0,
    right: 0,
    display: 'flex',
    justifyContent: 'center',
    zIndex: 200,
    pointerEvents: 'none',
  },
};